import React from "react";
import { IconButton, Stack } from "../components";
import { CheckCircle, CircleOutline } from "../icons";
export const ImageWithCheckbox = ({ id, image, selected, onClick, invertColors = false, }) => {
    return (React.createElement(Stack, { onClick: () => onClick(id), sx: {
            padding: 1,
            cursor: "pointer",
            alignItems: "flex-end",
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
            width: (theme) => theme.spacing(28.5),
            height: (theme) => theme.spacing(16),
            borderRadius: (theme) => theme.radius.xs5,
        } },
        React.createElement(IconButton, { variant: "minimal" }, selected ? (React.createElement(CheckCircle, { size: "xs", color: invertColors ? "background" : undefined })) : (React.createElement(CircleOutline, { size: "xs", color: invertColors ? "background" : undefined })))));
};
//# sourceMappingURL=ImageWithCheckbox.js.map